// extracted by mini-css-extract-plugin
export var loading__screen = "loading_screen-module--loading__screen--p4rex";